import * as React from 'react';
import * as styles from './ProjectItem.css';
import { ArticleParagraph1, ArticleParagraph2 } from '@cian/ui-kit';
import { IProjectItemProps } from '../../../types';

export const ProjectItem: React.FC<IProjectItemProps> = ({
  image,
  startPrice,
  features,
  materials,
  url,
  name,
  onClick,
}) => {
  return (
    <a href={url} target="_blank" className={styles['link']} rel="noreferrer" onClick={onClick}>
      <div className={styles['item']}>
        <div className={styles['image-container']}>
          <img src={image?.thumbnail} className={styles['image']} />
        </div>
        <div className={styles['info']}>
          <ArticleParagraph1>{name}</ArticleParagraph1>
          <ArticleParagraph1 fontWeight="700">{startPrice}</ArticleParagraph1>
          <ArticleParagraph1>{features}</ArticleParagraph1>
          <ArticleParagraph2>{materials}</ArticleParagraph2>
        </div>
      </div>
    </a>
  );
};
